import React from "react";
import { ApproverContext } from "../contextProviders/ApproverProvider";

export const useApprovers = () => {
    return React.useContext(ApproverContext);
}